import React, {useState} from 'react';
import {Button, Card, Col, Form, Modal, Row} from 'react-bootstrap';
import PropTypes from "prop-types";
import {getTenantErrorMessage, tenantsApi} from '../services/tenantsApi';

const SubTenantsSection = ({subTenants, tenant, path, isOwner, user, onNavigate}) => {
  const [showAddModal, setShowAddModal] = useState(false);
  const [newName, setNewName] = useState("");

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!newName) return;
    const result = await tenantsApi.createSubTenant({
      path,
      name: newName,
      user,
      tenant
    });

    if (!result.ok) {
      alert(getTenantErrorMessage(result.error, 'Failed to create sub-tenant.'));
      return;
    }

    setNewName("");
    setShowAddModal(false);
  };

  return (
    <div className="mb-5">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4>Sub-Tenants</h4>
        {isOwner && (
          <Button size="sm" onClick={() => setShowAddModal(true)}>+ New Sub-Tenant</Button>
        )}
      </div>
      {subTenants.length === 0 ? (
        <p className="text-muted">No sub-tenants found.</p>
      ) : (
        <Row xs={1} md={2} lg={3} className="g-3">
          {subTenants.map(sub => (
            <Col key={sub.id}>
              <Button variant="link" className="p-0 text-start text-decoration-none w-100 h-100"
                      onClick={() => onNavigate(sub.id)}>
                <Card className="island h-100 w-100">
                  <Card.Body>
                    <Card.Title>{sub.name || sub.id}</Card.Title>
                    <Card.Subtitle className="mb-2 text-muted text-truncate">{sub.id}</Card.Subtitle>
                  </Card.Body>
                </Card>
              </Button>
            </Col>
          ))}
        </Row>
      )}

      <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Create Sub-Tenant</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleCreate}>
          <Modal.Body>
            <Form.Group>
              <Form.Label>Tenant Name</Form.Label>
              <Form.Control
                autoFocus
                value={newName}
                onChange={e => setNewName(e.target.value)}
                placeholder="e.g. Branch Office Zurich"
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowAddModal(false)}>Cancel</Button>
            <Button variant="primary" type="submit">Create</Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
};

SubTenantsSection.propTypes = {
  subTenants: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string
  })).isRequired,
  tenant: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    parentTenantIds: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  path: PropTypes.string.isRequired,
  isOwner: PropTypes.bool.isRequired,
  user: PropTypes.shape({
    email: PropTypes.string,
    uid: PropTypes.string
  }).isRequired,
  onNavigate: PropTypes.func.isRequired
};

export default SubTenantsSection;
